import React, { Suspense } from 'react';
import Loader from '../../../../components/commons/helpers/loader/loader.component';

function NewAvaPositionsLandingPage({ page: { MainContent, breadCrumbList } }) {
  const HeroComponent = React.lazy(() =>
    import('./new-ava-positions-hero-component')
  );
  const ContentComponent = React.lazy(() =>
    import('./new-ava-positions-content-component')
  );

  return (
    <div className="ava-container">
      <Suspense fallback={<Loader />}>
        <HeroComponent
          MainContent={MainContent}
          breadCrumbList={breadCrumbList}
        />
      </Suspense>
      <Suspense fallback={<Loader />}>
        <ContentComponent MainContent={MainContent} />
      </Suspense>
    </div>
  );
}

export default NewAvaPositionsLandingPage;
